import HeaderStatic from './HeaderStatic';
import Footer from './Footer';
import { Link } from 'react-router-dom';
import { ArrowLeftIcon } from '@heroicons/react/24/outline';
import { FormattedMessage } from 'react-intl';

const ErrorPage = () => {

    return (
        <div id='error-page'>
            <HeaderStatic />
            <main className="grid min-h-full place-items-center bg-white px-6 py-32 sm:py-36 lg:px-8">
                <div className="text-center">
                <h1 className="mt-4 text-3xl font-bold tracking-tight text-gray-900 sm:text-5xl">
                    <FormattedMessage id="error.title" defaultMessage="Something went wrong..." />
                </h1>
                <p className="mt-6 text-base leading-7 text-gray-600">
                    <FormattedMessage id="error.message" defaultMessage="Sorry, we couldn’t find the page you’re looking for." />
                </p>
                <div className="mt-10 flex items-center justify-center gap-x-6">
                    <Link to="/" className="inline-flex items-center justify-center bg-[#1A658F] px-6 py-3 text-base font-medium text-white shadow-lg hover:bg-cyan-600 focus:outline-none focus:ring-2 focus:ring-cyan-600 focus:ring-offset-2 rounded-md">
                    <ArrowLeftIcon className='w-5 inline-block' /> <FormattedMessage id="app.back_to_meted" defaultMessage="Back to MetEd" />
                    </Link>
                </div>
                </div>
            </main>
            <Footer />
        </div>
    );
};

export default ErrorPage;